import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import { IconButton, Tooltip, Box, CircularProgress } from '@material-ui/core';
import { green, red, yellow } from '@material-ui/core/colors';

import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import CancelIcon from '@material-ui/icons/Cancel';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import FlagIcon from '@material-ui/icons/Flag';
import PanToolIcon from '@material-ui/icons/PanTool';
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import { getFretes, criarFrete, pagarFrete, gerarEtiquetaFrete, obterLinkEtiquetaFrete } from '../../store/actions/frete';
import TituloPagina from '../../components/layout/TituloPagina';
import DataTableComponent from '../../components/form/DataTableComponent';
import DialogAlert from '../../components/layout/DialogAlert';

const Fretes = props => {
    const history = useHistory();
    const {
        fretes,
        getFretes,
        criarFrete,
        pagarFrete,
        gerarEtiquetaFrete,
        obterLinkEtiquetaFrete,
        loading,
        processing
    } = props;

    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogConfig, setDialogConfig] = useState(null);

    useEffect(() => {
        getFretes();
    }, [getFretes]);

    const columns = [
        {
            name: 'ID',
            selector: (row) => row.id,
            width: '70px',
            sortable: true,
        },
        {
            name: <>ID<br />SubPedido</>,
            selector: (row) => row.pedidoVendedorId,
            width: '100px',
            sortable: true,
        },
        {
            name: 'Vendedor',
            selector: (row) => row.nomeVendedor,
            sortable: true,
        },
        {
            name: 'Transportadora',
            selector: (row) => row.transportadora,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Método',
            selector: (row) => row.metodoNome,
            sortable: true,
            width: '150px',
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (
                row.statusEntrega === 1
                    ? (
                        <Tooltip title='Aguardando pagamento do pedido' placement='right'><CreditCardIcon style={{ color: yellow[500] }} /></Tooltip>
                    ) :
                    row.statusEntrega === 2
                        ? (
                            <Tooltip title='Preparando envio' placement='right'><LocalShippingIcon style={{ color: yellow[700] }} /></Tooltip>
                        ) :
                        row.statusEntrega === 3
                            ? (
                                <Tooltip title='Postado' placement='right'><LocalShippingIcon style={{ color: green[700] }} /></Tooltip>
                            ) :
                            row.statusEntrega === 4
                                ? (
                                    <Tooltip title='Entregue' placement='right'><DoneAllIcon style={{ color: green[500] }} /></Tooltip>
                                ) :
                                row.statusEntrega === 5
                                    ? (
                                        <Tooltip title='Devolvido' placement='right'><CancelIcon style={{ color: red[500] }} /></Tooltip>
                                    ) :
                                    row.statusEntrega === 6
                                        ? (
                                            <Tooltip title='Cancelado' placement='right'><CancelIcon style={{ color: red[500] }} /></Tooltip>
                                        ) :
                                        row.statusEntrega === 7
                                            ? (
                                                <Tooltip title='Recebido em ponto de distribuição' placement='right'><FlagIcon style={{ color: green[500] }} /></Tooltip>
                                            ) :
                                            row.statusEntrega === 8
                                                ? (
                                                    <Tooltip title='Entrega pausada' placement='right'><PanToolIcon style={{ color: yellow[500] }} /></Tooltip>
                                                ) :
                                                row.statusEntrega === 9
                                                    ? (
                                                        <Tooltip title='Entrega suspensa' placement='right'><PanToolIcon style={{ color: red[500] }} /></Tooltip>
                                                    ) : (
                                                        null
                                                    )
            ),
            width: '100px',
            center: 'true',
        },
        {
            name: <>Link da<br />Etiqueta</>,
            selector: (row) => row.linkImpressaoEtiqueta != null ? <a href={row.linkImpressaoEtiqueta} target='_blank' rel='noreferrer'>Clique aqui</a> : 'Não disponível',
            width: '150px',
        },
        {
            name: 'Ações',
            center: 'true',
            cell: (row) => (
                <>
                    <Tooltip title='Detalhar Frete' placement='right'>
                        <IconButton style={{ padding: 1 }} aria-label="detalhar" size='small' color='secondary' onClick={() => handleDetalharFrete(row.id)}><SearchOutlinedIcon /></IconButton>
                    </Tooltip>
                    {row.statusEtiqueta === null ? (
                        <Tooltip title='Criar Frete' placement='right'>
                            <IconButton style={{ padding: 1 }} aria-label="criar-frete" size='small' color='secondary' onClick={() => handleAbrirConfirmacao(row, 'criar')}><LocalOfferOutlinedIcon /></IconButton>
                        </Tooltip>
                    ) : null}
                    {row.statusEtiqueta === 1 || row.statusEtiqueta === 4 ? (
                        <Tooltip title='Pagar Frete' placement='right'>
                            <IconButton style={{ padding: 1 }} aria-label="pagar-frete" size='small' color='secondary' onClick={() => handleAbrirConfirmacao(row, 'pagar')}><PaymentOutlinedIcon /></IconButton>
                        </Tooltip>
                    ) : null}
                    {row.statusEtiqueta === 2 ? (
                        <Tooltip title='Gerar Etiqueta' placement='right'>
                            <IconButton style={{ padding: 1 }} aria-label="gerar-etiqueta" size='small' color='secondary' onClick={() => handleAbrirConfirmacao(row, 'gerar-etiqueta')}><ReceiptOutlinedIcon /></IconButton>
                        </Tooltip>
                    ) : null}
                    {row.statusEtiqueta === 5 ? (
                        <Tooltip title='Obter Link da Etiqueta' placement='right'>
                            <IconButton style={{ padding: 1 }} aria-label="gerar-etiqueta" size='small' color='secondary' onClick={() => handleAbrirConfirmacao(row, 'link_etiqueta')}><ReceiptOutlinedIcon /></IconButton>
                        </Tooltip>
                    ) : null}
                    
                </>
            ),
            width: '100px'
        }
    ];

    const handleDetalharFrete = (id) => {
        history.push({
            pathname: '/fretes/detalhar-frete',
            state: {
                freteId: id
            },
        });
    };

    const handleAbrirConfirmacao = (row, tipo) => {
        setDialogConfig({ row, tipo });
        setDialogOpen(true);
    };

    const handleCancelarConfirmacao = () => {
        setDialogConfig(null);
        setDialogOpen(false);
    };

    const handleConfirmarAcao = () => {
        if (!dialogConfig) {
            return;
        }

        const { row, tipo } = dialogConfig;
        const pedidoVendedorId = row.pedidoVendedorId;

        if (tipo === 'criar') {
            criarFrete(pedidoVendedorId);
        } else if (tipo === 'pagar') {
            pagarFrete(pedidoVendedorId);
        } else if (tipo === 'gerar-etiqueta') {
            gerarEtiquetaFrete(pedidoVendedorId);
        } else {
            obterLinkEtiquetaFrete(pedidoVendedorId);
        }

        setDialogOpen(false);
        setDialogConfig(null);
    };

    const getDialogTitle = () => {
        if (!dialogConfig) {
            return 'Confirmar ação';
        }

        if (dialogConfig.tipo === 'criar') {
            return 'Criar frete';
        }

        if (dialogConfig.tipo === 'pagar') {
            return 'Pagar frete';
        }

        return 'Obter link da etiqueta';
    };

    const getDialogDescription = () => {
        if (!dialogConfig) {
            return 'Deseja confirmar esta ação?';
        }

        if (dialogConfig.tipo === 'criar') {
            return 'Tem certeza que deseja criar o frete para este pedido?';
        }

        if (dialogConfig.tipo === 'pagar') {
            return 'Tem certeza que deseja realizar o checkout do frete para este pedido?';
        }

        return 'Tem certeza que deseja gerar a etiqueta para este pedido?';
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo='Fretes' subtitulo={new Date().toLocaleString('pt-BR')} />

            <Box sx={{ height: '70vh' }}>
                <DataTableComponent
                    columns={columns}
                    data={fretes}
                    visibleSearch={fretes && fretes.length > 0}
                    camposParaBusca={['nomeVendedor', 'transportadora', 'metodoNome', 'id']}
                />
            </Box>

            <DialogAlert
                title={getDialogTitle()}
                okButton={true}
                okButtonClick={handleConfirmarAcao}
                cancelButtonClick={handleCancelarConfirmacao}
                labelOkButton={processing ? 'Processando...' : 'Confirmar'}
                cancelButton={true}
                labelCancelButton='Cancelar'
                openDialog={dialogOpen}
                okButtonType='button'
            >
                {getDialogDescription()}
            </DialogAlert>
        </>
    );
};

const mapStateToProps = state => ({
    fretes: state.frete.fretes,
    loading: state.frete.loading,
    processing: state.frete.processing,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getFretes,
    criarFrete,
    pagarFrete,
    gerarEtiquetaFrete,
    obterLinkEtiquetaFrete,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Fretes);